import { render, staticRenderFns } from "./contractFeeNewList.vue?vue&type=template&id=366b7978&scoped=true"
import script from "./contractFeeNewList.vue?vue&type=script&lang=js"
export * from "./contractFeeNewList.vue?vue&type=script&lang=js"
import style0 from "./contractFeeNewList.vue?vue&type=style&index=0&id=366b7978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366b7978",
  null
  
)

export default component.exports